import React from 'react';
import '../css/MissionVisionHero.css';

const MissionVisionHero = () => {
  return (
    <header className="gfi-mv-hero-inner-banner">
      
      {/* Solid Dark Indigo-Blue Dark Overlay Film according to screenshot 7_2 */}
      <div className="gfi-mv-hero-curtain-overlay"></div>

      <div className="gfi-mv-hero-canvas-container">
        <div className="gfi-mv-hero-content-alignment-box">
          
          {/* TRACKING PATH BREADCRUMB INDICATOR */}
          <nav className="gfi-mv-breadcrumb-navigation">
            <span className="gfi-mv-bc-home">HOME</span>
            <span className="gfi-mv-bc-divider">&gt;</span>
            <span className="gfi-mv-bc-current">MISSION, VISION & OBJECTIVES</span>
          </nav>

          {/* MASSIVE DUAL-TONE BRAND TYPOGRAPHY TITLE */}
          <h1 className="gfi-mv-hero-master-title">
            OUR MISSION & <br />
            <span className="gfi-mv-title-accent-blue">VISION</span>
          </h1>

        </div>
      </div>

    </header>
  );
};

export default MissionVisionHero;